/* eslint-disable max-len */
import React from 'react';

const Quote = () => (
  <div className="container">
    <h3>
      There are two ways to do great mathematics. The first is to be smarter
      than everybody else. The second way is to be stupider than everybody else
      — but persistent. — Raoul Bott.
    </h3>
    <h3>
      Mathematics is much less formally complete and precise than computer
      programs. — William Thurston.
    </h3>
    <h3>
      But in the new math approach, the important thing is to understand what
      you are doing, rather than to get the right answer. — Tom Lehrer.
    </h3>
  </div>
);

export default Quote;
